export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 6.09C4 3.815 5.808 2 8 2s4 1.815 4 4.09c0 1.892-1.083 3.899-2.3 5.527a20.757 20.757 0 01-1.64 1.924l-.06.063-.06-.063a20.757 20.757 0 01-1.64-1.924C5.083 9.989 4 7.982 4 6.09zm3.334 9.656L8 15l-.665.747a1 1 0 001.33 0L8 15c.665.747.665.747.666.746l.002-.002.004-.003.013-.013a7.815 7.815 0 00.22-.205 22.75 22.75 0 002.395-2.708c1.282-1.713 2.7-4.16 2.7-6.724C14 2.744 11.33 0 8 0S2 2.744 2 6.09c0 2.564 1.417 5.012 2.7 6.725a22.748 22.748 0 002.395 2.708 12.852 12.852 0 00.22.205l.013.013.004.003.002.002zM8 8a2 2 0 100-4 2 2 0 000 4z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};